<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import ProdutoRequest from 'Modules/contacard/produto/product/ProdutoRequest';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ProductCategoriaColumnVue from './components/columns/ProductCategoriaColumn.vue';
import ProductTypeOperationColumnVue from './components/columns/ProductTypeOperationColumn.vue';
import ProductTypeValueColumnVue from './components/columns/ProductTypeValueColumn.vue';

export default {
  name: 'ProdutoCrudList',
  extends: CrudListVue,
  data: () => ({
    requestClass: ProdutoRequest,
    editRoute: 'product.edit',
    hideDelete: true,
    headers: [
      {
        text: 'Produto',
        value: 'nomProdutoServico',
      },
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Categoria',
        value: 'produtoServicoCategoria',
        component: ProductCategoriaColumnVue,
      },
      {
        text: 'Tipo operação',
        value: 'tipoOperacao',
        component: ProductTypeOperationColumnVue,
      },
      {
        text: 'Tipo valor produto',
        value: 'tipoValorProduto',
        component: ProductTypeValueColumnVue,
      },
      {
        text: 'Observação',
        value: 'txtObservacao',
        tooltip: true,
      },
      {
        text: 'Valor produto',
        value: 'vlrProdutoServico',
        component: 'DataTableCurrencyColumn',
      },
      {
        text: 'Valor máx',
        value: 'vlrVariavelMax',
        component: 'DataTableCurrencyColumn',
      },
      {
        text: 'Valor min',
        value: 'vlrVariavelMin',
        component: 'DataTableCurrencyColumn',
      },
      {
        text: 'Última atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  methods: {
    editAction(item) {
      this.goTo(
        this.editRoute,
        {
          id: item.id,
          productType: item.produtoServicoCategoria,
        },
      );
    },
  },
};
</script>
